import './Hidden.scss';

function Hidden({ children }: { children: React.ReactNode }) {
	return <div className="Hidden">{children}</div>;
}

export default Hidden;
